import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import DeletePDFPagesImagesListScreen from "./DeletePDFPagesImagesListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function DeletePDFPagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Delete PDF Pages" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/delete_pdf_pages", title: "Remove PDF Pages" },
    data2: {
      link: "/delete_pdf_pages",
      title: "Remove Selected Pages From PDF",
    },
    data3: { link: "/delete_pdf_pages", title: "Delete PDF Pages Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Delete PDF pages online easily. Remove unwanted pages, edit PDFs, and manage documents quickly with our fast, secure PDF page remover tool."
      ></meta>
      <meta
        name="keywords"
        content="delete PDF pages, remove pages from PDF, PDF page remover, edit PDF online, delete PDF online, PDF editor tool, remove unwanted PDF pages, manage PDF pages, online PDF page editor, PDF document editor, PDF management tool, delete pages in PDF, trim PDF pages, PDF editing tool, PDF page deletion"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <DeletePDFPagesImagesListScreen
          title={title}
        ></DeletePDFPagesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Delete PDF Pages Offline website provides a fast, secure, and efficient solution to remove unwanted pages from PDF files directly on your device, without requiring an internet connection. Designed for privacy-conscious users, this powerful tool allows you to remove PDF pages, delete selected pages for PDF, and filter documents easily while keeping your files completely offline and secure. Unlike cloud-based tools, all processing happens locally, ensuring sensitive documents never leave your device. The website also supports optional online usage, enabling users to delete PDF pages online or remove PDF pages online for free when internet access is available. Whether you need to clean up large PDFs, remove blank pages, delete confidential sections, or organize documents for sharing, this tool delivers accurate results without affecting the remaining content. With advanced page selection options, users can filter PDF files, preview pages, and delete specific pages in seconds. The platform supports delete PDF pages for free, making it ideal for students, professionals, and businesses looking for a cost-effective PDF solution. Text, images, and formatting are preserved perfectly after page removal, ensuring professional-quality output. Compatible with desktop and mobile devices, this offline PDF page remover helps you manage documents efficiently, save storage space, and prepare PDFs for email, uploads, and official submissions. If you are searching for a secure way to remove PDF pages, delete PDF pages online, remove PDF pages online for free, or delete selected pages for PDF with complete privacy, this website offers a reliable, user-friendly PDF management solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Delete",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Delete PDF Pages"
            why_use={[
              {
                title: "Remove Unwanted PDF Pages Easily",
                description:
                  "Large PDF files often contain extra or blank pages. A delete PDF pages tool helps you quickly remove PDF pages and keep only the relevant content.",
              },
              {
                title: "Delete Selected Pages for PDF Files",
                description:
                  "When only specific pages need to be removed, a delete selected pages for PDF feature allows precise editing without affecting the rest of the document.",
              },
              {
                title: "Reduce PDF File Size",
                description:
                  "Removing unnecessary pages helps shrink document size. Tools that delete PDF pages online create lightweight PDFs for easy sharing and storage.",
              },
              {
                title: "Protect Sensitive Information",
                description:
                  "A remove PDF pages tool helps eliminate confidential or private pages before sharing documents with others.",
              },
              {
                title: "Filter PDF Content Efficiently",
                description:
                  "Advanced tools let you filter PDF pages and remove irrelevant sections, improving document organization and usability.",
              },
              {
                title: "Easy Sharing and Uploading",
                description:
                  "Using a delete PDF pages for free tool helps meet file size limits for email, online forms, and website uploads.",
              },
              {
                title: "Preserve Original Quality and Layout",
                description:
                  "Modern remove PDF pages online for free tools maintain text clarity, images, and formatting after page deletion.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "An offline delete PDF pages tool processes files locally, keeping your documents secure without uploading them online.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals often delete PDF pages online to customize assignments, reports, contracts, and presentations.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I delete pages from a PDF online for free?",
                description:
                  "Visit ShivaPDF.com and open the Delete PDF Pages tool. Select your PDF file, choose the pages you want to remove, and apply the changes. Download the updated PDF directly to your device."
              },
              {
                title: "Can I delete PDF pages without uploading my file?",
                description:
                  "Yes, ShivaPDF processes supported PDF files locally in your browser, allowing you to delete pages without uploading your document contents to a remote server. Your files remain on your device during local processing."
              },
              {
                title: "Is ShivaPDF's Delete PDF Pages tool free?",
                description:
                  "Yes, ShivaPDF offers a free PDF page deletion tool that lets you remove unwanted pages from PDF documents without installing additional software, subject to any usage limits displayed on the website."
              },
              {
                title: "Can I delete PDF pages offline?",
                description:
                  "You may need an internet connection to open ShivaPDF.com initially. If the Delete PDF Pages tool and its required resources are available locally, you can remove PDF pages without an active internet connection."
              },
              {
                title: "Are my PDF files safe when deleting pages with ShivaPDF?",
                description:
                  "ShivaPDF is designed to process supported PDF files locally in your browser. Local processing means document contents do not need to be uploaded to a remote server, helping you keep your files private and under your control."
              },
              {
                title: "How do I remove a single page from a PDF?",
                description:
                  "Open the Delete PDF Pages tool on ShivaPDF.com, select your PDF, and choose the page you want to remove. Apply the changes and download the updated document without the selected page."
              },
              {
                title: "Can I delete multiple pages from a PDF at once?",
                description:
                  "Yes, you can select multiple unwanted pages and remove them in one operation if supported by the tool. This is useful for cleaning up large documents without editing each page separately."
              },
              {
                title: "Can I delete a range of pages from a PDF?",
                description:
                  "If page range selection is supported, you can specify a range of pages to remove from your PDF. Review the selected page numbers carefully before applying the changes."
              },
              {
                title: "Can I delete pages from the middle of a PDF?",
                description:
                  "Yes, you can remove selected pages from the middle of a PDF while keeping the remaining pages in their original order. The resulting document contains the pages that were not deleted."
              },
              {
                title: "Can I delete the first or last page of a PDF?",
                description:
                  "Yes, you can remove the first page, last page, or other unwanted pages from a PDF using the available page selection options. Make sure the document retains the pages you need before downloading it."
              },
              {
                title: "Will deleting PDF pages affect the remaining content?",
                description:
                  "Deleting pages removes the selected pages from the output PDF while preserving the remaining pages. Review the downloaded document to ensure its content and page order are correct."
              },
              {
                title: "Will deleting PDF pages reduce the file size?",
                description:
                  "Yes, removing pages can reduce PDF file size because the deleted pages and their associated content are removed from the resulting document. The amount of space saved depends on the content of the deleted pages."
              },
              {
                title: "Can I delete pages from a scanned PDF?",
                description:
                  "Yes, supported scanned PDFs can be edited to remove unwanted scanned pages. You do not need to scan the document again; simply select the pages you want to delete."
              },
              {
                title: "Can I delete PDF pages on my mobile phone?",
                description:
                  "Yes, you can use ShivaPDF.com in a supported browser on an iPhone, Android phone, or tablet. Select your PDF, mark the pages you want to remove, and download the updated file."
              },
              {
                title: "Do I need to install software to delete PDF pages?",
                description:
                  "No, ShivaPDF provides a browser-based PDF page deletion tool. You can remove unwanted pages directly in your browser without installing a separate PDF editor."
              },
              {
                title: "Will deleting pages change my original PDF?",
                description:
                  "Your original PDF remains unchanged when you download the edited document as a separate file. Keep a copy of the original if you might need the deleted pages later."
              },
              {
                title: "Can I delete pages from a password-protected PDF?",
                description:
                  "Some password-protected PDFs require authorization or unlocking before they can be edited. Only modify protected documents when you have permission to do so."
              },
              {
                title: "Can I delete PDF pages without creating an account?",
                description:
                  "You can use the Delete PDF Pages tool without creating an account if registration is not required by the website. Check the tool page for any applicable usage restrictions."
              },
              {
                title: "Does ShivaPDF store my PDF files?",
                description:
                  "ShivaPDF's local-processing workflow is designed to handle supported PDF files in your browser without uploading their contents to a remote server. This helps keep your documents on your device during processing."
              },
              {
                title: "How do I download a PDF after deleting pages?",
                description:
                  "After selecting and deleting the unwanted pages, use the download option to save the updated PDF to your device. Open the downloaded file to verify that the correct pages were removed."
              },
              {
                title: "Why should I use a local PDF page remover?",
                description:
                  "A local PDF page remover lets you edit supported documents directly in your browser without uploading their contents to a remote server. It offers a convenient way to remove unwanted pages while helping protect document privacy."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default DeletePDFPagesMain;
